// API Configuration
// HBRabbits

// Determine BASE_URL based on the domain
const getBaseUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:5000/api/v1";
    //   return "https://cbrexqa-asfpgzb6gxc9ffax.canadacentral-01.azurewebsites.net/api/v1";
  } else if (hostname === "cbrexadmin.pages.dev") {
    return "https://cbrexqa-asfpgzb6gxc9ffax.canadacentral-01.azurewebsites.net/api/v1";
  } else {
    // Default fallback
    return "https://cbrexqa-asfpgzb6gxc9ffax.canadacentral-01.azurewebsites.net/api/v1";
  }
};

// Public-facing site base URL (for "View on public site" links)
const getPublicSiteBaseUrl = () => {
  if (process.env.REACT_APP_PUBLIC_SITE_URL) {
    return process.env.REACT_APP_PUBLIC_SITE_URL;
  }
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "https://cbre-x.online";
  }
  return "https://cbre-x.online";
};

export const API_CONFIG = {
  BASE_URL: getBaseUrl(),
  PUBLIC_SITE_BASE_URL: getPublicSiteBaseUrl(),
  CORS_PROXIES: [
    "https://cors-anywhere.herokuapp.com/",
    "https://api.allorigins.win/raw?url=",
    "https://corsproxy.io/?",
  ],
};

// BASRUS
// export const CLOUDFLARE_CONFIG = {
//   ACCOUNT_ID: "2ddb54b9a392b4e89a1bedae18bd910a",
//   API_TOKEN: "FYFNVBJeADIHVAMuYK8shwJfR8kPe8sQan4e3FXG",
//   IMAGES_ENDPOINT:
//     "https://api.cloudflare.com/client/v4/accounts/2ddb54b9a392b4e89a1bedae18bd910a/images/v1",
//   STREAM_ENDPOINT:
//     "https://api.cloudflare.com/client/v4/accounts/2ddb54b9a392b4e89a1bedae18bd910a/stream",
// };

// CBREX
export const CLOUDFLARE_CONFIG = {
  ACCOUNT_ID: "53e6dabae145e9e880de8d5194e44bc5",
  API_TOKEN: "xovQszkj1KCxxRIOW2mUPRTciVBiauj7ebJFPz5T",
  CFPREFIX: "https://customer-foi6l8f9e3qadhq4.cloudflarestream.com/",
  IMAGES_ENDPOINT:
    "https://api.cloudflare.com/client/v4/accounts/53e6dabae145e9e880de8d5194e44bc5/images/v1",
  STREAM_ENDPOINT:
    "https://api.cloudflare.com/client/v4/accounts/53e6dabae145e9e880de8d5194e44bc5/stream",
};
